import { render, staticRenderFns } from "./ExternalClientItem.vue?vue&type=template&id=ac0bae36&"
import script from "./ExternalClientItem.vue?vue&type=script&lang=ts&"
export * from "./ExternalClientItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QItemLabel}, component.options.components || {})
